// extracted by mini-css-extract-plugin
export default {"input":"FVtfhU","checkedCheckbox":"KpR0Gi","wrapper":"afLkiT","checkbox":"dhYsbT","policy":"vjOgLF","labelContainer":"JXpFFg","checkboxLabel":"Md6M5G","checkboxWrapper":"Dk_OrZ"};